(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rv-home-orientation"] && !Shopify.designMode) return;
  try {
    
  const initRiftValleyCategorySliders = (scope = document) => {
    scope.querySelectorAll('[data-rv-category-slider]').forEach((slider) => {
      if (slider.dataset.rvSliderReady === 'true') return;
      slider.dataset.rvSliderReady = 'true';

      const section = slider.closest('.rv-home-orientation');
      const previous = section?.querySelector('[data-rv-category-prev]');
      const next = section?.querySelector('[data-rv-category-next]');
      const getDistance = () => {
        const firstCard = slider.querySelector('.rv-home-orientation__card');
        if (!firstCard) return slider.clientWidth * 0.8;
        const styles = getComputedStyle(slider);
        return firstCard.getBoundingClientRect().width + parseFloat(styles.columnGap || styles.gap || 0);
      };

      previous?.addEventListener('click', () => slider.scrollBy({ left: -getDistance(), behavior: 'smooth' }));
      next?.addEventListener('click', () => slider.scrollBy({ left: getDistance(), behavior: 'smooth' }));
    });
  };

  initRiftValleyCategorySliders();
  document.addEventListener('shopify:section:load', (event) => initRiftValleyCategorySliders(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rv-product-details"] && !Shopify.designMode) return;
  try {
    
  const placeRiftValleyProductDetails = () => {
    const details = document.querySelector('[data-rv-product-details]');
    const target = document.querySelector('.product-details__right');
    if (!details || !target) return false;
    const host = details.closest('.shopify-section--rv-product-details') || details.closest('.shopify-section');
    if (host && !target.contains(host)) target.append(host);
    if (host) host.classList.add('rv-product-details-host--inline');
    return true;
  };

  const placeRiftValleyFrequentlyBoughtTogether = () => {
    const target = document.querySelector('.product-details__left .product-details--left')
      || document.querySelector('.product-details__left');
    if (!target) return false;

    const appBlock = document.querySelector('[id*="frequently_bought_app_block"]');
    const appHost = appBlock?.closest('.product-details__block') || appBlock;
    if (appHost && !target.contains(appHost)) target.prepend(appHost);

    let slot = target.querySelector('#frequently-bought-together-app-block');
    if (!slot) {
      slot = document.createElement('div');
      slot.id = 'frequently-bought-together-app-block';
      target.prepend(slot);
    }
    slot.classList.add('rv-frequently-bought-together');

    const widgets = Array.from(document.querySelectorAll('.cbb-frequently-bought-container'))
      .filter((widget) => widget.querySelector('.cbb-frequently-bought-products') || widget.textContent.trim() !== '');

    widgets.forEach((widget) => {
      if (!slot.contains(widget)) slot.append(widget);

      const products = Array.from(widget.querySelectorAll('.cbb-frequently-bought-products > .cbb-frequently-bought-product'));
      products.forEach((product, index) => {
        product.classList.toggle('rv-fbt-hidden-recommendation', index > 1);
      });

      const selectors = Array.from(widget.querySelectorAll('.cbb-frequently-bought-selector-list > li'));
      selectors.forEach((selector, index) => {
        const isExtraRecommendation = index > 1;
        selector.classList.toggle('rv-fbt-hidden-recommendation', isExtraRecommendation);

        const input = selector.querySelector('.cbb-frequently-bought-selector-input');
        if (isExtraRecommendation && input?.checked) input.click();
      });
    });

    return widgets.length > 0;
  };

  let placementFrame;
  const placeRiftValleyProductContent = () => {
    window.cancelAnimationFrame(placementFrame);
    placementFrame = window.requestAnimationFrame(() => {
      placeRiftValleyProductDetails();
      placeRiftValleyFrequentlyBoughtTogether();
    });
  };

  placeRiftValleyProductContent();

  const placementObserver = new MutationObserver(placeRiftValleyProductContent);
  placementObserver.observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('shopify:section:load', placeRiftValleyProductContent);
  document.addEventListener('shopify:section:reorder', placeRiftValleyProductContent);

  } catch(e) { console.error(e); }
})();
})();
